import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { connect } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import NumberDisplay from '../../../../components/number-display';
import QueryExplantionModal from './ContactQueryExplainationModal';
import styles from './styles.css';


function GroupRowInnerRenderer(props) {
  let text = props.value;
  if (props.value === 'account_contacts') {
    text = 'Account Contacts';
  } else if (props.value === 'opportunity_contacts') {
    text = 'Opportunity Contacts';
  } else if (props.value === 'gong_contacts') {
    text = 'Gong Contacts';
  } else if (props.value === 'activity_contacts') {
    text = 'Contact with Activities';
  }

  
  return (
    <strong>{text}</strong>
  );
}


function NameRenderer(props) {
  const { data } = props;
  if (!data) {
    return null;
  }
  const isPrimary = data.is_primary === true;
  const doNotContact = data.do_not_contact === true;
  

  const star = (
    <Fa className={isPrimary ? 'text-warning' : 'invisible'} name="star" />
  );

  const tip = isPrimary ? (
    <Tooltip id={`primary-${data.contact_id}`}>
      <div>Primary Contact</div>
    </Tooltip>
  ) : null;


  let banned = null;
  if (doNotContact) {
    const tip2 = (
      <Tooltip id={`banned-${data.contact_id}`}>
        <div>Do not contact</div>
      </Tooltip>
    );
    banned = (
      <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="right" overlay={tip2}>
        <Fa name="banned" className="text-danger" />
      </OverlayTrigger>
    );  
  }

  const indicator = isPrimary ? (
    <OverlayTrigger key="button" trigger={['hover', 'focus']} placement="right" overlay={tip}>
      {star}
    </OverlayTrigger>
  ) : star;

  return (
    <span>
      {indicator} {data.name} {banned}
    </span>
  );
}



function TVValidRenderer(props) {
  const { data } = props;
  if (!data) {
    return null;
  }
  const isValid = data.valid === true;
  if (!isValid) {
    return null;
  }

  const isTVValid = data.tv_valid === true;

  if (isTVValid) {
    return null;
  }

  return (
    <Fa name="exclamation-triangle" className="text-warning" />
  );
}


function QualidfiedRenderer(props) {
  const { data } = props;
  if (!data) {
    return null;
  }
  const isValid = data.valid === true;
  const isTVValid = data.tv_valid === true;

  const cmps = [
    (
      <span key="main" className={`text-uppercase label label-${isValid ? 'success' : 'danger'}`}>
        {isValid ? 'Passed' : 'Failed'}
      </span>
    ),
    ...(isValid && !isTVValid ? [(<span key="space">&nbsp;</span>), <TVValidRenderer key="sec" {...props} />] : []),
  ];
  
  return (
    <span style={{ cursor: 'pointer' }}>{cmps}</span>
  );
}

class ContactList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentContact: null,
      showModal: false,
    };
    this.getRowClass = this.getRowClass.bind(this);
    this.getExtraColumns = this.getExtraColumns.bind(this);
    this.handleCellClick = this.handleCellClick.bind(this);
    this.handleHideModal = this.handleHideModal.bind(this);
  }

  getRowClass(params) {
    const { node: { data } } = params;
    if (data) {
      
      if (data.valid === true && data.tv_valid === true) {
        return styles.rowSuccess;
      }
      if (data.valid === false) {
        return styles.rowError;
      }
      if (data.tv_valid === false) {
        return styles.rowWarning;
      }
     
    }
    return null;
  }

  handleCellClick({ data }) {
    if (data) {
      console.clear();
      console.log('data', data);
      this.setState({ currentContact: data, showModal: true });
    }
  }

  handleHideModal() {
    this.setState({ showModal: false }, () => {
      this.setState({ currentContact: null });
    });
  }

  getExtraColumns() {
    return [
      {
        colId: 'result',
        headerName: 'Trigger Conditions',
        width: 140,
        hide: false,
        pinned: 'right',
        suppressMiniFilter: true,
        suppressSorting: true,
        suppressMenu: true,
        suppressMovable: true,
        suppressToolPanel: true,
        field: 'is_matched',
        cellRenderer: 'resultRenderer',
        cellStyle: () => ({ cursor: 'pointer' }),
        onCellClicked: this.handleCellClick,
        /*
        valueGetter: this.resultValueGetter,
        cellRendererParams: {
          column: {
            label: 'Submitted Results',
          },
        },
        */
      },
    ];
  }

  renderContactList() {
    const tableHeight = `400px`;
    const { contacts } = this.props;

    const columnDefs = [
      {
        headerName: 'Contact',
        width: 200,
        field: 'name',
        suppressMenu: true,
        cellRenderer: NameRenderer,
      },
      {
        headerName: 'Email',
        width: 220,
        field: 'email',
        suppressMenu: true,
      },
      {
        headerName: 'Title',
        width: 180,
        field: 'title',
        suppressMenu: true,
      },


      {
        headerName: 'Role',
        width: 150,
        field: 'role',
        suppressMenu: true,
      },

      {
        headerName: 'Source',
        field: 'source',
        suppressMenu: true,
        rowGroup: true,
        hide: true,
      },

      {
        headerName: 'Qualidfied',
        width: 100,
        field: 'valid',
        suppressMenu: true,
        cellRenderer: QualidfiedRenderer,
        onCellClicked: this.handleCellClick,
      },
    ];

    return (
      <div className="ag-theme-alpine" style={{ height: tableHeight, width: '100%' }} >
        <AgGridReact
          reactNext
          enableColResize
          enableSorting
          onGridReady={this.onGridReady}
          columnDefs={columnDefs}
          rowData={contacts}
          getRowClass={this.getRowClass}
          groupDefaultExpanded={-1}
          groupDisplayType="groupRows"
          groupRowRendererParams={{
            innerRenderer: GroupRowInnerRenderer,
          }}
        />
      </div>
    );
  }

  render() {
    const { contacts, totalMatched } = this.props;
    const total = contacts.length;

    
    const header = (
      <div className="alert alert-default">
        {totalMatched > 0 && <span>Found <NumberDisplay value={totalMatched} suffix="contact" precision={0} suffixIsUnit /></span>}
        {totalMatched === 0 && <span>Found no contacts</span>}
        {' '}
        that matched the trigger conditions.
      </div>
    );
    
    let body = null;
    if (total > 0) {
      body = this.renderContactList();
    } else {
      // mothing found
      body = (
        <div className="alert alert-warning">No contacts found</div>
      );
    }
    

    return (
      <div>
        {header}
        {body}
        {this.state.currentContact !== null &&
          <QueryExplantionModal
            contact={this.state.currentContact}
            isAccount={this.props.isAccount}
            account={this.props.account}
            opportunity={this.props.opportunity}
            owner={this.props.owner}
            contactType={this.state.currentContact.source}
            show={this.state.showModal}
            settings={this.props.settings}
            automationId={this.props.automationId}
            onClose={this.handleHideModal}
          />
        }
      </div>
    );
  }
}


// Retrieve data from store as props
function mapStateToProps(/* state */) {
  return {
  };
}

ContactList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  settings: PropTypes.shape({}),
  automationId: PropTypes.string,
  contacts: PropTypes.arrayOf(PropTypes.shape({})),
  totalMatched: PropTypes.number,
  opportunity: PropTypes.shape({

  }),
  account: PropTypes.shape({}).isRequired,
  isAccount: PropTypes.bool,
  owner: PropTypes.shape({}).isRequired,
};
ContactList.defaultProps = {
  settings: {},
  contacts: [],
  totalMatched: 0,
  automationId: null,
  opportunityId: null,
  accountId: null,
  ownerId: null,
  isAccount: false,
};

export default connect(mapStateToProps)(ContactList);
